import { MapPin } from 'lucide-react';
import { DAY_OF_WEEK_LABELS, type DayOfWeek } from '@paulownia/shared/types';
import type { CurrentMarketInfo } from '@paulownia/shared/lib/storage';

interface CurrentMarketBannerProps {
  currentMarket: CurrentMarketInfo;
  onChangeClick: () => void;
}

/**
 * Sticky banner displaying the active market context on merchant pages.
 * Always visible, always accessible.
 */
export function CurrentMarketBanner({ currentMarket, onChangeClick }: CurrentMarketBannerProps) {
  return (
    <div className="bg-orange-50 border-b border-orange-100 px-4 py-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-sm">
          <MapPin className="w-4 h-4 text-orange-600 flex-shrink-0" />
          <span className="text-gray-700">
            <span className="font-medium">Marche actuel :</span>{' '}
            {currentMarket.city} — {DAY_OF_WEEK_LABELS[currentMarket.dayOfWeek as DayOfWeek]}
          </span>
        </div>
        <button
          onClick={onChangeClick}
          className="text-sm text-orange-600 font-medium hover:text-orange-700 whitespace-nowrap ml-2"
        >
          Changer
        </button>
      </div>
    </div>
  );
}
